import { CheckCircle, Pause, PowerOff, Clock } from 'lucide-react';

export const STATUS_CONFIG = {
  actif: { label: 'Actif', color: 'bg-green-700', icon: CheckCircle },
  suspendu: { label: 'Suspendu', color: 'bg-orange-600', icon: Pause },
  inactif: { label: 'Inactif', color: 'bg-gray-600', icon: PowerOff },
  en_attente: { label: 'En attente', color: 'bg-blue-600', icon: Clock },
};

export const PAYS_OPTIONS = [
  { code: 'FR', nom: 'France', indicatif: '+33', flag: 'https://flagcdn.com/w40/fr.png' },
  { code: 'GP', nom: 'Guadeloupe', indicatif: '+590', flag: 'https://flagcdn.com/w40/gp.png' },
  { code: 'MQ', nom: 'Martinique', indicatif: '+596', flag: 'https://flagcdn.com/w40/mq.png' },
  { code: 'GF', nom: 'Guyane française', indicatif: '+594', flag: 'https://flagcdn.com/w40/gf.png' },
  { code: 'RE', nom: 'La Réunion', indicatif: '+262', flag: 'https://flagcdn.com/w40/re.png' },
  { code: 'YT', nom: 'Mayotte', indicatif: '+262', flag: 'https://flagcdn.com/w40/yt.png' },
  { code: 'NC', nom: 'Nouvelle-Calédonie', indicatif: '+687', flag: 'https://flagcdn.com/w40/nc.png' },
  { code: 'PF', nom: 'Polynésie française', indicatif: '+689', flag: 'https://flagcdn.com/w40/pf.png' },
  { code: 'PM', nom: 'Saint-Pierre-et-Miquelon', indicatif: '+508', flag: 'https://flagcdn.com/w40/pm.png' },
  { code: 'WF', nom: 'Wallis-et-Futuna', indicatif: '+681', flag: 'https://flagcdn.com/w40/wf.png' },
  { code: 'BL', nom: 'Saint-Barthélemy', indicatif: '+590', flag: 'https://flagcdn.com/w40/bl.png' },
  { code: 'MF', nom: 'Saint-Martin', indicatif: '+590', flag: 'https://flagcdn.com/w40/mf.png' },
  { code: 'BE', nom: 'Belgique', indicatif: '+32', flag: 'https://flagcdn.com/w40/be.png' },
  { code: 'CH', nom: 'Suisse', indicatif: '+41', flag: 'https://flagcdn.com/w40/ch.png' },
  { code: 'LU', nom: 'Luxembourg', indicatif: '+352', flag: 'https://flagcdn.com/w40/lu.png' },
  { code: 'MC', nom: 'Monaco', indicatif: '+377', flag: 'https://flagcdn.com/w40/mc.png' },
];

export const TERRITOIRES = [
  { id: 'metropole', nom: 'France Métropolitaine', zone: 'Europe' },
  { id: 'guadeloupe', nom: 'Guadeloupe', zone: 'Antilles' },
  { id: 'martinique', nom: 'Martinique', zone: 'Antilles' },
  { id: 'guyane', nom: 'Guyane', zone: 'Amérique du Sud' },
  { id: 'reunion', nom: 'La Réunion', zone: 'Océan Indien' },
  { id: 'mayotte', nom: 'Mayotte', zone: 'Océan Indien' },
  { id: 'nouvelle-caledonie', nom: 'Nouvelle-Calédonie', zone: 'Pacifique' },
  { id: 'polynesie', nom: 'Polynésie française', zone: 'Pacifique' },
  { id: 'saint-pierre', nom: 'Saint-Pierre-et-Miquelon', zone: 'Amérique du Nord' },
  { id: 'wallis', nom: 'Wallis-et-Futuna', zone: 'Pacifique' },
  { id: 'saint-barthelemy', nom: 'Saint-Barthélemy', zone: 'Antilles' },
  { id: 'saint-martin', nom: 'Saint-Martin', zone: 'Antilles' },
];

export const SPECIALITES = [
  'Bâtiment', 'Travaux Publics', 'Génie Civil', 'Électricité', 'Plomberie',
  'Charpente', 'Couverture', 'Maçonnerie', 'Menuiserie', 'Peinture',
  'Carrelage', 'Isolation', 'Chauffage / Climatisation', "Multi-corps d'état", 'Autre'
];
